import React from "react";
import { I } from "../data";
import { useAuth } from "../AuthContext";
import { useWorkspace } from "../WorkspaceContext";
import { VidhyaMark } from "./VidhyaMark";
import VidhyaWordmark from "./VidhyaWordmark";

export default function Sidebar({ view, go, openCmd, open, onClose }) {
  const { user, logout } = useAuth();
  const { universities, tasks, scholarships } = useWorkspace();

  const taskCount = tasks.filter((t) => !t.done).length;
  const initials = (user?.name || "U").split(" ").map((s) => s[0]).slice(0, 2).join("").toUpperCase();
  const planLabel = user?.plan === "navigator" ? "Navigator plan · Billing" : "Free plan · Upgrade";

  const NavItem = ({ id, label, icon, badge }) => {
    const Icon = I[icon];
    return (
      <div className={`vnav-item ${view === id ? "active" : ""}`} onClick={() => go(id)} data-testid={`nav-${id}`}>
        <Icon size={19} />
        <span>{label}</span>
        {badge != null && <span className="vnav-badge">{badge}</span>}
      </div>
    );
  };

  return (
    <aside className={`vrail ${open ? "open" : ""}`} data-testid="sidebar">
      <div className="vbrand2" data-testid="brand">
        <div className="l" onClick={() => go("dashboard")}>
          <VidhyaWordmark size={52} />
        </div>
        <button type="button" className="vicon-btn mobile-only" onClick={onClose} aria-label="Close menu" data-testid="sidebar-close-btn" style={{ width: 30, height: 30 }}>
          <I.Close size={14} />
        </button>
      </div>

      <button className="vask" onClick={() => go("chat")} data-testid="sidebar-ask-vidhya">
        <span className="vask-mark"><VidhyaMark size={17} /></span> Ask Vidhya <span className="kbd">⌘K</span>
      </button>

      <nav className="vnav">
        <NavItem id="dashboard" label="Home" icon="Home" />
        <NavItem id="board" label="My Universities" icon="Board" badge={universities.length || null} />
        <NavItem id="tasks" label="Tasks" icon="Check" badge={taskCount || null} />
        <NavItem id="scholarships" label="Scholarships" icon="Trophy" badge={scholarships.length || null} />
        <NavItem id="profile" label="Profile" icon="User" />
      </nav>

      {universities.length > 0 && (
        <>
          <div className="vnavlabel">Recent</div>
          <nav className="vnav">
            {universities.slice(0, 4).map((u) => (
              <div key={u.id} className="vnav-item" onClick={() => go("detail", u.id)} data-testid={`recent-uni-${u.id}`}>
                <span className="vrail-uni">{u.short?.[0] || u.name[0]}</span>
                <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{u.short || u.name.slice(0, 14)}</span>
              </div>
            ))}
          </nav>
        </>
      )}

      <div className="vrail-sp" />

      <div className="vnavlabel">Account</div>
      <nav className="vnav">
        <NavItem id="autofill" label="Autofill" icon="Bolt" />
        <NavItem id="billing" label="Billing & plan" icon="Settings" />
        {user?.role === "admin" && <NavItem id="admin" label="Admin console" icon="Shield" />}
      </nav>

      <div className="vme" data-testid="profile-card" onClick={() => go("billing")}>
        <div className="vav">{initials}</div>
        <div style={{ minWidth: 0, flex: 1 }}>
          <b style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{user?.name}</b>
          <span>{planLabel}</span>
        </div>
        <button className="vme-logout" onClick={(e) => { e.stopPropagation(); logout(); }} title="Sign out" data-testid="logout-btn">
          <I.Logout size={14} />
        </button>
      </div>
    </aside>
  );
}
